<div class="h-full w-full flex flex-col justify-center items-center gap-2">
  <mat-icon class="animate-spin icon-size-7 text-[#0f766e]" svgIcon="heroicons_outline:viewfinder-circle" viewBox="0 0 24 24">
  </mat-icon>
  <span class="text-lg">Пожалуйста, подождите!</span>
</div>
